import { Component } from "react";
import { bindActionCreators } from 'redux';
import { actions } from "react-redux-form";
import { SelectFieldFloatingLabel as Select } from "../../../../../common/custom-form/select-filter.component";
import { TRANSLATIONS as translation } from "../../../../../../utils/constant.utils";

import { connect } from "react-redux";
import { MAX_LENGTH, OUTPUT_COLUMN_SOURCE } from "../../../../../../constants/external-constants";
import { InputFieldFloatingLabel as InputField } from "../../../../../common/custom-form/select-filter.component";
import { OutputConfigurationDetailsActions } from "../../../../../../store/external/recharge-reducer/output-configuraton-details/output-configuration-details.reducer";

class OutputMultipleColumn extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        const { rowColumnName, outputConfigurationDetails, viewMulitpleOutputColumn, setOriginalMultipleSourceData } = this.props;
        const { multipleOutputColumnsDatatable } = outputConfigurationDetails;

        const dataTable = multipleOutputColumnsDatatable?.dataTable;
        const dataItems = Array.isArray(dataTable) && dataTable.length > 0 ? dataTable[0]?.dataItem : null;

        if (Array.isArray(dataItems) && dataItems.length > 0) {
            const matchedItem = dataItems.find(item => item.ColumnName === rowColumnName);

            if (matchedItem) {
                const dataItem = { ...matchedItem, ID: -1 };
                const wrappedTable = [[dataItem]];

                viewMulitpleOutputColumn(0, wrappedTable);
                setOriginalMultipleSourceData(wrappedTable);
            }
        }
    }

    toLocaleLanguage = (key, isCapitalize = true) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return isCapitalize ? translation[locale][key]?.toUpperCase() : translation[locale][key];
    }

    render() {
        const { columnSourceOption, columnFormat1Option, columnFormat2Option, columnFormat3Option, optionLabelKey, fieldForm, fieldProp } = this.props;
        const disableColumnFormat1 = parseInt(fieldForm.ColumnSourceID1) === parseInt(OUTPUT_COLUMN_SOURCE.None.id) || !fieldForm.ColumnSourceID1;
        const disableColumnFormat2 = parseInt(fieldForm.ColumnSourceID2) === parseInt(OUTPUT_COLUMN_SOURCE.None.id) || !fieldForm.ColumnSourceID2;
        const disableColumnFormat3 = parseInt(fieldForm.ColumnSourceID3) === parseInt(OUTPUT_COLUMN_SOURCE.None.id) || !fieldForm.ColumnSourceID3;
        return (
            <div className="output-multiple-column">
                <div className="output-multiple-column__form message-form-body">
                    <div className="grid-col-3">
                        <Select
                            className="form-select required"
                            label={`${this.toLocaleLanguage('column_source')} 1`}
                            options={columnSourceOption}
                            value={fieldForm.ColumnSourceID1}
                            placeholder={this.toLocaleLanguage('select_placeholder', false)}
                            isError={false}
                            fieldProp={fieldProp + 'ColumnSourceID1'}
                            onChangeAction={(m, v) => this.props.filterColumnFormatByIndex(1, m, v)}
                            optionLabelKey={optionLabelKey}
                        />
                        <Select
                            className="form-select required"
                            label={`${this.toLocaleLanguage('column_source')} 2`}
                            options={columnSourceOption}
                            value={fieldForm.ColumnSourceID2}
                            placeholder={this.toLocaleLanguage('select_placeholder', false)}
                            isError={false}
                            fieldProp={fieldProp + 'ColumnSourceID2'}
                            onChangeAction={(m, v) => this.props.filterColumnFormatByIndex(2, m, v)}
                            optionLabelKey={optionLabelKey}
                        />
                        <Select
                            className="form-select required"
                            label={`${this.toLocaleLanguage('column_source')} 3`}
                            options={columnSourceOption}
                            value={fieldForm.ColumnSourceID3}
                            placeholder={this.toLocaleLanguage('select_placeholder', false)}
                            isError={false}
                            fieldProp={fieldProp + 'ColumnSourceID3'}
                            onChangeAction={(m, v) => this.props.filterColumnFormatByIndex(3, m, v)}
                            optionLabelKey={optionLabelKey}
                        />
                        <Select
                            className={`form-select ${!disableColumnFormat1 ? 'required' : ''}`}
                            label={`${this.toLocaleLanguage('column_format')} 1`}
                            options={columnFormat1Option}
                            value={fieldForm.ColumnFormatID1}
                            disabled={disableColumnFormat1}
                            placeholder={disableColumnFormat1 ? '' : this.toLocaleLanguage('select_placeholder', false)}
                            isError={false}
                            fieldProp={fieldProp + 'ColumnFormatID1'}
                            optionLabelKey={optionLabelKey}
                        />
                        <Select
                            className={`form-select ${!disableColumnFormat2 ? 'required' : ''}`}
                            label={`${this.toLocaleLanguage('column_format')} 2`}
                            options={columnFormat2Option}
                            value={fieldForm.ColumnFormatID2}
                            disabled={disableColumnFormat2}
                            placeholder={disableColumnFormat2 ? '' : this.toLocaleLanguage('select_placeholder', false)}
                            isError={false}
                            fieldProp={fieldProp + 'ColumnFormatID2'}
                            optionLabelKey={optionLabelKey}
                        />
                        <Select
                            className={`form-select ${!disableColumnFormat3 ? 'required' : ''}`}
                            label={`${this.toLocaleLanguage('column_format')} 3`}
                            options={columnFormat3Option}
                            value={fieldForm.ColumnFormatID3}
                            disabled={disableColumnFormat3}
                            placeholder={disableColumnFormat3 ? '' : this.toLocaleLanguage('select_placeholder', false)}
                            isError={false}
                            fieldProp={fieldProp + 'ColumnFormatID3'}
                            optionLabelKey={optionLabelKey}
                        />
                        <InputField
                            className={`form-control required`}
                            type="text"
                            label={this.toLocaleLanguage('column_name')}
                            value={fieldForm.ColumnName}
                            fieldProp={fieldProp + 'ColumnName'}
                            maxLength={MAX_LENGTH.limit_255}
                            placeholder={`${this.toLocaleLanguage('enter_text_placeholder', false)}`}
                            isError={this.props.haveColumnError}
                        />
                        <div className="grid-col-span-2">
                            <InputField
                                className={`form-control required`}
                                type="text"
                                label={this.toLocaleLanguage('column_values')}
                                value={fieldForm.Values}
                                fieldProp={fieldProp + 'Values'}
                                maxLength={MAX_LENGTH.limit_100}
                                placeholder={`${this.toLocaleLanguage('enter_text_placeholder', false)}`}
                                isError={this.props.haveValueError}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    state => {
        const { translation, outputConfigurationDetails } = state;
        return {
            ...translation,
            outputConfigurationDetails
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, OutputConfigurationDetailsActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value));
        },
    })
)(OutputMultipleColumn);